// extracted by mini-css-extract-plugin
module.exports = {"border-table":"Modals_border-table__1eKvQ","min-row-height":"Modals_min-row-height__2OAcz"};